.c2{overflow:hidden;}